<template>
    <el-select v-bind="{...$attrs,...$props}" v-on="$listeners" @change="handleChange">
        <slot></slot>
    </el-select>
</template>

  <script>
  import { Select } from 'element-ui';
  
  export default {
    name: 'JtTreeSelect',
  
    // 继承自 ElSelect 组件
    extends: Select,
  
    props: {
      name: String,
      id: String,
      value: {
        required: true
      },
      autocomplete: {
        type: String,
        default: 'off'
      },
      /** @Deprecated in next major version */
      autoComplete: {
        type: String,
        validator(val) {
          process.env.NODE_ENV !== 'production' &&
            console.warn('[Element Warn][Select]\'auto-complete\' property will be deprecated in next major version. please use \'autocomplete\' instead.');
          return true;
        }
      },
      automaticDropdown: Boolean,
      size: String,
      disabled: Boolean,
      clearable: Boolean,
      filterable: Boolean,
      allowCreate: Boolean,
      loading: Boolean,
      popperClass: String,
      remote: Boolean,
      loadingText: String,
      noMatchText: String,
      noDataText: String,
      remoteMethod: Function,
      filterMethod: Function,
      multiple: Boolean,
      multipleLimit: {
        type: Number,
        default: 0
      },
      placeholder: {
        type: String,
        required: false
      },
      defaultFirstOption: Boolean,
      reserveKeyword: Boolean,
      valueKey: {
        type: String,
        default: 'value'
      },
      collapseTags: Boolean,
      popperAppendToBody: {
        type: Boolean,
        default: true
      }
    },
  
    methods: {
      // 你可以在这里覆盖或替换一些方法

      toggleMenu(e) {
      // 判断是否input输入框，如果input框有值，并且有选中的文字，则不触发
        let $target = e.target;
        let isInput = $target.tagName.toLowerCase() === 'input';
        let isHasValue = !!$target.value;
        // 获取选中的文字
        let text = window.getSelection().toString();  
        if(isInput&&isHasValue&&text.length>0) return;

        if (!this.selectDisabled) {
          if (this.menuVisibleOnFocus) {
            this.menuVisibleOnFocus = false;
          } else {
            this.visible = !this.visible;
          }
          if (this.visible) {
            (this.$refs.input || this.$refs.reference).focus();
          }
        }
      },

      handleChange(value) {
        // 替换 el-select 的 on-change 方法
        console.log('Custom Select Changed:', value);
  
        // 调用原有的 on-change 方法
        this.$emit('change', value);
      },
  
      // 你还可以自定义其他方法
      customMethod() {
        console.log('This is a custom method');
      }
    },
  
    watch: {
      value(newValue) {
        console.log('Value changed:', newValue);
      }
    }
  };
  </script>
  